// Vendor libraries
import $ from "jquery";
window.$ = $;
window.jQuery = $;
import Rails from "@rails/ujs";
Rails.start();
import "jquery-ui/ui/widgets/datepicker";
import "bootstrap/dist/js/bootstrap.bundle";
import "admin-lte/dist/js/adminlte";

// Vendor CSS (imported as CSS, not through SCSS)
import "bootstrap/dist/css/bootstrap.css";
import "admin-lte/dist/css/adminlte.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "jquery-ui/themes/base/datepicker.css";
import "jquery-ui/themes/base/theme.css";

// App SCSS
import "./stylesheets/application.scss";

// App JS
import "./src/form_helpers";
import "./src/redemptions";
import "./src/scheme_applications";
